module.exports = __webpack_public_path__ + "static/media/twitter.5a071f46.svg";